module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAMCAYAAACNzvbFAAAAAXNSR0IArs4c6QAAAJVJREFUKBW90ksKgCAQBuCmRZvuGBSIF/AIRV1BbBcdsW32T1T0spfQgP6izCeCpLUuiEhZa6PgY6G/Q38upayYCDGkD8gI+mOE4jUXo2Zc+U/NTBBuIWNMjczmzbeJ57dCiATZcy/x5APvwQX9Cp+BG/Qt7AIP6FP4CjxF7+A70Im64CfgJbqCS/yOdAIVcvw2fP5rDaETdDLohv9YAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/city-arrow.png
// module id = 4yAm
// module chunks = 1